import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const SalesSummary = ({ salesData }) => {
  return (
    <>
      <Box
        sx={{
          p: { sm: "20px 50px", xs: "10px 30px" },
          background: "#fff",
          borderRadius: "10px",
        }}
      >
        <Grid container spacing={1}>
          {/* Header */}
          <Grid item xs={6}></Grid>
          <Grid item xs={3}>
            <Typography
              align="center"
              fontWeight="600"
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "16px", md: "18px" },
              }}
            >
              Today's
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              align="center"
              fontWeight="600"
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "16px", md: "18px" },
              }}
            >
              Monthly
            </Typography>
          </Grid>

          {/* Data Rows */}
          {salesData.map((item, idx) => (
            <Grid
              container
              key={idx}
              component={Paper}
              elevation={2}
              sx={{
                my: "5px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid item xs={6}>
                <Box p={{ xs: 1, sm: 0 }}>
                  <Typography
                    fontWeight={500}
                    color="primary"
                    sx={{
                      marginLeft: { md: "40px", xs: "0px" },

                      fontSize: { xs: "12px", sm: "16px", md: "18px" },
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box p={0}>
                  <Typography
                    align="center"
                    color="primary"
                    sx={{
                      fontSize: { xs: "12px", sm: "16px", md: "18px" },
                    }}
                  >
                    {item.today}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box p={0}>
                  <Typography
                    align="center"
                    color="primary"
                    sx={{
                      fontSize: { xs: "12px", sm: "16px", md: "18px" },
                    }}
                  >
                    {item.monthly}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ height: "30px", width: "100%" }}></Box>
    </>
  );
};

export default SalesSummary;
